import React from 'react';
import { motion } from 'framer-motion';
type Node = {
  id: string;
  x: number;
  y: number;
  label: string;
};
const sources: Node[] = [{
  id: 'yelp',
  x: 40,
  y: 60,
  label: 'Yelp'
}, {
  id: 'google',
  x: 30,
  y: 165,
  label: 'Google'
}, {
  id: 'site',
  x: 48,
  y: 275,
  label: 'Website'
}, {
  id: 'referral',
  x: 36,
  y: 375,
  label: 'Referral'
}];
const hub = {
  x: 235,
  y: 218
};
const booked = {
  x: 420,
  y: 218
};
function curve(from: {
  x: number;
  y: number;
}, to: {
  x: number;
  y: number;
}) {
  const midX = (from.x + to.x) / 2;
  return `M ${from.x} ${from.y} C ${midX} ${from.y}, ${midX} ${to.y}, ${to.x} ${to.y}`;
}
export function LeadFlowVisual() {
  return <div className="relative w-full" data-id="element-303" data-mp="1ac2gtcrj8gz3">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full bg-emerald-500/10 blur-3xl" aria-hidden="true" data-id="element-304" data-mp="15ekg29no5826" />
      <svg viewBox="0 0 480 440" className="relative w-full" role="img" aria-label="Diagram showing leads from Yelp, Google, your website and referrals flowing into one system and out as booked jobs" data-id="element-305" data-mp="2guqwjpw7a777">
        <defs data-id="element-306" data-mp="32iiu9otxpjci">
          <radialGradient id="hubGlow" data-id="element-307" data-mp="32m6oyrb48bst">
            <stop offset="0%" stopColor="#10b981" stopOpacity="0.35" data-id="element-308" data-mp="37ioqzjf29w1g" />
            <stop offset="100%" stopColor="#10b981" stopOpacity="0" data-id="element-309" data-mp="37hdodmxcqubx" />
          </radialGradient>
        </defs>

        <circle cx={hub.x} cy={hub.y} r="110" fill="url(#hubGlow)" data-id="element-310" data-mp="2euj0sh58neu8" />

        {sources.map((node, i) => {
        const path = curve(node, hub);
        return <g key={node.id} data-id="element-311" data-mp="2jtvspgayvc3o" data-mpi={i}>
              <path d={path} stroke="#232323" strokeWidth="1.25" fill="none" data-id="element-312" data-mp="2osyw6wbata9j" />
              <motion.path d={path} stroke="#10b981" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeDasharray="26 400" initial={{
            strokeDashoffset: 426
          }} animate={{
            strokeDashoffset: [426, 0]
          }} transition={{
            duration: 2.6,
            repeat: Infinity,
            ease: 'linear',
            delay: i * 0.65
          }} data-id="element-313" data-mp="2oqvw1jgfm0r3" />
              <circle cx={node.x} cy={node.y} r="5" fill="#0a0a0a" stroke="#2f2f2f" data-id="element-314" data-mp="22srmg55v1138" />
              <motion.circle cx={node.x} cy={node.y} r="5" fill="#10b981" initial={{
            opacity: 0.25
          }} animate={{
            opacity: [0.25, 1, 0.25]
          }} transition={{
            duration: 2.6,
            repeat: Infinity,
            delay: i * 0.65
          }} data-id="element-315" data-mp="1xtf0dmmtby1p" />
              <text x={node.x + 14} y={node.y + 4} className="font-mono" fontSize="11" fill="#8a8a8a" letterSpacing="0.08em" data-id="element-316" data-mp="1k2jm1utjooqq">
                {node.label.toUpperCase()}
              </text>
            </g>;
      })}

        <path d={curve(hub, booked)} stroke="#232323" strokeWidth="1.25" fill="none" data-id="element-317" data-mp="2qk6qc2dabqgl" />
        <motion.path d={curve(hub, booked)} stroke="#10b981" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeDasharray="30 260" initial={{
        strokeDashoffset: 290
      }} animate={{
        strokeDashoffset: [290, 0]
      }} transition={{
        duration: 2.2,
        repeat: Infinity,
        ease: 'linear',
        delay: 0.9
      }} data-id="element-318" data-mp="c8qg0maccvjl" />

        <motion.circle cx={hub.x} cy={hub.y} r="52" fill="none" stroke="#10b981" strokeOpacity="0.35" animate={{
        r: [52, 74],
        strokeOpacity: [0.35, 0]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeOut'
      }} data-id="element-319" data-mp="vyu23054w3zb" />
        <circle cx={hub.x} cy={hub.y} r="46" fill="#101010" stroke="#10b981" strokeOpacity="0.5" data-id="element-320" data-mp="r57n31bhzo0c" />
        <text x={hub.x} y={hub.y - 2} textAnchor="middle" className="font-mono" fontSize="11" fill="#10b981" letterSpacing="0.1em" data-id="element-321" data-mp="1eutlvnnyk17t">
          ANSWERED
        </text>
        <text x={hub.x} y={hub.y + 15} textAnchor="middle" className="font-mono" fontSize="10" fill="#6b6b6b" letterSpacing="0.1em" data-id="element-322" data-mp="3m7lgxj3nzfy9">
          24/7
        </text>

        <circle cx={booked.x} cy={booked.y} r="6" fill="#10b981" data-id="element-323" data-mp="3d99hcrktl7to" />
        <text x={booked.x} y={booked.y - 18} textAnchor="middle" className="font-mono" fontSize="11" fill="#d4d4d4" letterSpacing="0.08em" data-id="element-324" data-mp="dsjo7swouxwx">
          BOOKED
        </text>
      </svg>
    </div>;
}